import React, { useState, useContext, createContext, useEffect } from 'react';
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import FormSignUp from './FormSignUp';
import { APP_NAME, USER_REGISTRATION } from 'constant';
import { useHistory } from 'react-router-dom';
import tokenService from 'services/auth.service';
import Verification from './Verification';
import useDictionary from 'hooks/useDictionary';
import './styles.scss';
import LangIcons from 'app/components/LangIcons';
import { logo } from 'images';

const SignUpContext = createContext({});

SignUpContext.displayName = 'SignUpContext';

export const useSignUp = () => {
  const context = useContext(SignUpContext);
  return context;
};

const SignUp = () => {
  const history = useHistory();
  const [modeView, setModeView] = useState({
    type: 'verification',
  });
  const { t }: any = useDictionary({});
  const value: any = { t };

  const renderContent = () => {
    switch (modeView?.type) {
      case 'signup':
        return <FormSignUp />;
      case 'verification':
        return <Verification />;
      default:
        return <NotFoundPage />;
    }
  };
  useEffect(() => {
    const timeNow = new Date().getTime();
    const userRegistration: string | null =
      localStorage.getItem(USER_REGISTRATION);
    const dataUser: any = userRegistration
      ? JSON.parse(userRegistration)
      : null;
    const waiting: boolean =
      parseInt(dataUser?.expired) > timeNow ? true : false;
    if (history.location.search === '') {
      tokenService.removeUserRegistration();
      setModeView({
        type: 'signup',
      });
    } else if (
      (history.location.search === '?verification-code' ||
        history.location.search === '?resend-code') &&
      waiting
    ) {
      setModeView({
        type: 'verification',
      });
    } else {
      history.push('/signup');
      tokenService.removeUserRegistration();
    }
  }, [history, history.location.search]);
  const loadingAll = false;

  return (
    <SignUpContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <div className="sign-up">
          <LoadPanel visible={loadingAll} />
          <div className="singup-main">
            <div className="singup-container">
              <div className="left">
                <div className="title">
                  {t('Visibility, Efficiency, Sustainability')}
                  <div className="sub-title">
                    {t('ONE PRODUCT OF DOOSOUN-CNI')}
                  </div>
                </div>
              </div>
              <div className="right">
                <div className="right-header">
                  <div className="right-logo">
                    <img src={logo} alt={APP_NAME} width={32} />
                    <div>{APP_NAME}</div>
                  </div>
                  <LangIcons />
                </div>
                <div className="content">{renderContent()}</div>
                <div className="footer">
                  <div>{t('© 2024 Doosoun - CNI. All rights reserved')}</div>
                  <div className="mail-help">
                    <i className="dx-icon-email" />
                    <span>{'help@snacksplanet.com'}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Suspense>
    </SignUpContext.Provider>
  );
};

export default SignUp;
